import React from "react";
import Popover from "components/Popover";
import Icon from "components/Icon";
import cn from "classnames";
import IconButton from "components/IconButton";
import SelectList, {
    SelectListItem,
    SelectListDivider,
    SelectListLabel,
} from "playground/ui/SelectList";

//import PropTypes from 'prop-types';

function LangSelect({ items, value, icon, onChange }) {
    return (
        <SelectList>
            {items.map((lang) => (
                <SelectListItem
                    key={lang.id}
                    onClick={() => onChange(lang.id)}
                    isSelected={value.includes(lang.id)}
                    checkbox={true}
                    checkboxIcon={icon}
                >
                    {lang.label}
                </SelectListItem>
            ))}
        </SelectList>
    );
}

export function LanguageSettings(props) {
    const {
        languages,
        visibleLanguages,
        value,
        onChange,
        onChangeLang,
        currentLang,
    } = props;
    const changeMode = (mode) => {
        onChange({
            ...value,
            mode: mode,
        });
    };

    const toggleNoExport = () => {
        onChange({ ...value, disable_export: !value.disable_export });
    };

    const toggleLang = (lang, key) => {
        const prev = value[key] || [];
        const newValue = prev.includes(lang)
            ? prev.filter((l) => l !== lang)
            : [...prev, lang];
        onChange({ ...value, [key]: newValue });
    };

    const modeLabels = {
        0: "Widoczne we wszystkich wersjach",
        1: "Widoczne tylko w wybranych wersjach",
        2: "Ukryte w wybranych wersjach",
    };

    const modeKeys = {
        0: null,
        1: "include",
        2: "exclude",
    };

    const modeIcons = {
        1: "mui-check",
        2: "mui-close",
    };

    const langSelectComponent = (
        <LangSelect
            items={languages}
            value={value[modeKeys[value.mode]]}
            onChange={(lang) => toggleLang(lang, modeKeys[value.mode])}
            icon={modeIcons[value.mode]}
        />
    );

    if (!languages.length) {
        return (
            <div className={"translations-nav pad-md cols-center"}>
                <Icon>mui-warning</Icon> Nie skonfigurowano wersji językowych
            </div>
        );
    }

    return (
        <div>
            <div className={"translations-nav cols cols-spread"}>
                <div className={"lang-nav cols"}>
                    {visibleLanguages.map((lang) => (
                        <div
                            className={cn("lang-nav-item", {
                                "is-selected": currentLang === lang.id,
                            })}
                            onClick={() => onChangeLang(lang.id)}
                        >
                            {lang.label}
                        </div>
                    ))}
                </div>
                <div className={"cols cols-middle gap-sm"}>
                    {languages.length !== visibleLanguages.length && (
                        <div>
                            {visibleLanguages.length} z {languages.length}
                        </div>
                    )}
                    <Popover
                        trigger={({ onClick }) => (
                            <IconButton
                                onClick={onClick}
                                icon={"mui-settings"}
                            />
                        )}
                        content={({ onClose }) => (
                            <SelectList>
                                <SelectListItem
                                    onClick={() => changeMode(0)}
                                    isSelected={!value.mode}
                                >
                                    Wszystkie języki
                                </SelectListItem>
                                <SelectListItem
                                    onClick={() => changeMode(1)}
                                    isSelected={value.mode === 1}
                                >
                                    Tylko wybrane języki
                                </SelectListItem>
                                {value.mode === 1 && langSelectComponent}
                                <SelectListItem
                                    onClick={() => changeMode(2)}
                                    isSelected={value.mode === 2}
                                >
                                    Ukryj w wybranych językach
                                </SelectListItem>
                                {value.mode === 2 && langSelectComponent}
                                <SelectListDivider />
                                <SelectListLabel>
                                    Serwisy tłumaczeniowe
                                </SelectListLabel>
                                <SelectListItem
                                    onClick={() => toggleNoExport()}
                                    checkbox={true}
                                    isSelected={!value.disable_export}
                                    checkboxIcon={"mui-check"}
                                    checkboxUncheckedIcon={"mui-close"}
                                >
                                    {value.disable_export
                                        ? "Nie udostępniaj"
                                        : "Udostępnij"}
                                </SelectListItem>
                            </SelectList>
                        )}
                    />
                </div>
            </div>
        </div>
    );
}

LanguageSettings.propTypes = {};

LanguageSettings.defaultProps = {
    languages: [],
    value: {},
};

export default LanguageSettings;
